import { useEffect } from 'react';
import { isEqual } from 'lodash';

import { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import usePrevious from 'Utilities/hooks/usePrevious';

export const useOnFiltersChanged = (callback: () => void): void => {
	const filters = useFilters();
	const prevFilters = usePrevious(filters);

	useEffect(() => {
		if (prevFilters && !isEqual(filters, prevFilters)) {
			callback();
		}
	}, [filters, prevFilters, callback]);
};
